export const navigationRoutes = [
    // { name: 'Home', href: '/' },
    // { name: 'Try It', href: '/try-it' },
    // { name: 'PocketQuant v. ChatGPT', href: '/pq-v-chatgpt'},
    // { name: 'Pricing', href: '/pricing' },
    { name: 'Changelog', href: '/changelog' },
    { name: 'Earnings Calendar', href: '/earnings-calendar'},
    // { name: 'Congressional Trading', href: '/congressional-graph'},
    { name: 'Blog', href: '/blogs' },
    { name: 'Learning Center', href: '/learning-center' },
]

export const funnelRoutes = [
    { name: 'Home', href: '/' },
    { name: 'Try It', href: '/try-it' },
    { name: 'Pricing', href: '/pricing' },
    { name: 'PocketQuant v. ChatGPT', href: '/pq-v-chatgpt'},
    { name: 'SignUp', href: '/signup' },
]